import React from "react";

const Publications = () => (
    <div className="row publications">
	<div className="three columns header-col">
	    <h1>
		<span>Publications</span>
	    </h1>
	</div>
	
	<div className="nine columns main-col">
	    <div className="row item">
	        <div className="six columns">
	          <h4 className="mb0">
	            Rosalee C.
	          </h4>
	          <p className="info">
	            So to Speak
	            <span>&bull;</span>
	            2015
	          </p>
	          <p />
	        </div>
	        <div className="six columns">
	          <h4 className="mb0">
	            Advice for Haitian Boys
	          </h4>
	          <p className="info">
	            Runaway Parade
	            <span>&bull;</span>
	            2013
	          </p>
	          <p />
	        </div>
	    </div>
	    <div className="row item">
	        <div className="six columns">
	          <h4 className="mb0">
	            Convalescence
	          </h4>
	          <p className="info">
	            Off the Coast
	            <span>&bull;</span>
	            2013
	          </p>
	          <p />
	        </div>
	        <div className="six columns">
	          <h4 className="mb0">
	            music, cloudy
	          </h4>
	          <p className="info">
	            Off the Coast
	            <span>&bull;</span>
	            2013
	          </p>
	          <p />
	        </div>
	    </div>
	    <div className="row item">
	        <div className="six columns">
	          <h4 className="mb0">
	            One Thousand Seven Hundred and Fifty-Two Inches
	          </h4>
	          <p className="info">
	            Off the Coast
	            <span>&bull;</span>
	            2013
	          </p>
	          <p />
	        </div>
	        <div className="six columns">
	          <h4 className="mb0">
	            I Never Noticed Flies
	          </h4>
	          <p className="info">
	            Breathing Poetry
	            <span>&bull;</span>
	            2009
	          </p>
	          <p />
	        </div>
	    </div>
	    <div className="row item">
	        <div className="six columns">
	          <h4 className="mb0">
	            Einstein&#x27;s Nightmare
	          </h4>
	          <p className="info">
	            Indiefeed Performance Poetry
	            <span>&bull;</span>
	            2009
	          </p>
	          <p />
	        </div>
	        <div className="six columns">
	          <h4 className="mb0">
	            Ode to the Common People
	          </h4>
	          <p className="info">
	            Boston University
	            <span>&bull;</span>
	            2008
	          </p>
	          <p />
	        </div>
	    </div>
	    <div className="row item">
	        <div className="six columns">
	          <h4 className="mb0">
	            Boston&#x27;s First Night - Live
	          </h4>
	          <p className="info">
	            Boston
	            <span>&bull;</span>
	            2007
	          </p>
	          <p />
	        </div>
	        <div className="six columns">
	          <h4 className="mb0">
	            Dear Boston University
	          </h4>
	          <p className="info">
	            Boston University: Points of Departure
	            <span>&bull;</span>
	            2007
	          </p>
	          <p />
	        </div>
	    </div>
	    <div className="row item">
	        <div className="six columns">
	          <h4 className="mb0">
	            XX Blood Brother
	          </h4>
	          <p className="info">
	            The Clarion
	            <span>&bull;</span>
	            2007
	          </p>
	          <p />
	        </div>
	        <div className="six columns">
	          <h4 className="mb0">
	            B Mynor
	          </h4>
	          <p className="info">
	            The Clarion
	            <span>&bull;</span>
	            2007
	          </p>
	          <p />
	        </div>
	    </div>
	    <div className="row item">
	        <div className="six columns">
	          <h4 className="mb0">
	            Hail-Mary Missiles
	          </h4>
	          <p className="info">
	            The Clarion
	            <span>&bull;</span>
	            2007
	          </p>
	          <p />
	        </div>
	        <div className="six columns">
	          <h4 className="mb0">
	            The Ridgework of His Fingertips are Signatures
	          </h4>
	          <p className="info">
	            The Clarion
	            <span>&bull;</span>
	            2007
	          </p>
	          <p />
	        </div>
	    </div>
	    <div className="row item">
	        <div className="six columns">
	          <h4 className="mb0">
	            D20 Heavy Water
	          </h4>
	          <p className="info">
	            Indiefeed Performance Poetry
	            <span>&bull;</span>
	            2006
	          </p>
	          <p />
	        </div>
	        <div className="six columns">
	          <h4 className="mb0">
	            Haiku for an Imagined Love
	          </h4>
	          <p className="info">
	            Burn Magazine
	            <span>&bull;</span>
	            2006
	          </p>
	          <p />
	        </div>
	    </div>
	    <div className="row item">
	        <div className="six columns">
	          <h4 className="mb0">
	            It&#x27;s Real
	          </h4>
	          <p className="info">
	            Burn Magazine
	            <span>&bull;</span>
	            2006
	          </p>
	          <p />
	        </div>
	        <div className="six columns">
	          <h4 className="mb0">
	            NYC / Boston
	          </h4>
	          <p className="info">
	            The Clarion
	            <span>&bull;</span>
	            2005
	          </p>
	          <p />
	        </div>
	    </div>
	    <div className="row item">
	        <div className="six columns">
	          <h4 className="mb0">
	            Home
	          </h4>
	          <p className="info">
	            The Clarion
	            <span>&bull;</span>
	            2005
	          </p>
	          <p />
	        </div>
	        <div className="six columns">
	          <h4 className="mb0">
	            a lit cigarette
	          </h4>
	          <p className="info">
	            The Clarion
	            <span>&bull;</span>
	            2005
	          </p>
	          <p />
	        </div>
	    </div>
	    <div className="row item">
	        <div className="six columns">
	          <h4 className="mb0">
	            Extended Metaphor
	          </h4>
	          <p className="info">
	            The Clarion
	            <span>&bull;</span>
	            2004
	          </p>
	          <p />
	        </div>
	        <div className="six columns">
	          <h4 className="mb0">
	            I broke bread with...
	          </h4>
	          <p className="info">
	            The Clarion
	            <span>&bull;</span>
	            2004
	          </p>
	          <p />
	        </div>
	    </div>
        </div>
    </div>
);

export default Publications;



// WEBPACK FOOTER //
// ./src/components/resume/Publications.jsx